// vim: set ts=2 sts=2 sw=2 et:

import React from "react";

import styles from "./BroadcastCanvas.module.scss";

const CANVAS_WIDTH = 1920;
const CANVAS_HEIGHT = 1080;

const readScale = () => Math.min(window.innerWidth / CANVAS_WIDTH, window.innerHeight / CANVAS_HEIGHT);

interface Props {
  label: string;
  children: React.ReactNode;
}

// Lienzo fijo de 1920×1080 escalado a la ventana: overlay y ficha se diseñan en píxeles de ese lienzo y se ven
// igual en una fuente de OBS de cualquier tamaño.
const BroadcastCanvas = ({ label, children }: Props) => {
  const [scale, setScale] = React.useState(readScale);
  React.useEffect(() => {
    const onResize = () => setScale(readScale());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return (
    <div className={styles.viewport}>
      <main className={styles.canvas} style={{ transform: `translate(-50%, -50%) scale(${scale})` }} aria-label={label}>
        {children}
      </main>
    </div>
  );
};

export default BroadcastCanvas;
